export enum ELogCrossWindowEvents {
  SEND_LOG_FROM_INTEGRATION_TO_HOST = '__send_log_from_integration_to_host__',
}

export enum EIntegrationCrossWindowEvents {
  CONNECTION_CHECK = '__host_requesting_connection_check__',
  REQUEST_CONFIG = '__integration_requesting_config__',
}

export interface ICrossWindowMessageData<T = unknown> {
  eventName: string;
  timestamp: number;
  payload?: T;
  messageId?: string;
}

export interface ICrossWindowLogEntry {
  timestamp: number;
  level: 'debug' | 'info' | 'warn' | 'error';
  message: string;
  topic: string;
  data?: unknown;
}

export const SDK_SUPPORTED_CROSS_WINDOW_EVENTS: Array<string> = [
  ...Object.values(EIntegrationCrossWindowEvents),
  ...Object.values(ELogCrossWindowEvents),
];
